import React, {useState} from "react";
import Modal from "react-modal";
import { sendGetRequest } from '../../../../helper/Helper'; 

const XMultiplierCalculator = () => {
    const [showResult, setShowResult] = useState(false);
    const [address, setAddress] = useState('0xbeA0e55b82Eb975280041F3b49C4D0bD937b72d5');
    const [xFactor, setXFactor] = useState('2');
    const [targetPrice, setTargetPrice] = useState('0.05');
    const [result, setResult] = useState([]);

    const calculateMultiplier = async () => {
        const response = await sendGetRequest(`ufo/pairs-volumes/latest/by-pair-address?pair_address=${address}`);
        if (response && response.status === 200)  {
            setResult(response.data);
            setShowResult(true);
        } else {
            setShowResult(false);
        }
    };

    function calculatePotential(startPrice, targetPrice) {
        const potential = ((targetPrice - startPrice) / startPrice);
        return potential < 0 ? '0.00' : parseFloat(potential).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return (
    <>
    <div className="container">
        <div className="row justify-content-between">
            <div className="col-xl-12 slR order1">
                <div className=" statsALL  pt-0 ">
                    <div className="bSRIN overHide subcontent">
                        <div className="snPortal">
                            <div className="SRTOP d-flex flex-wrap justify-content-between align-items-center">
                                <h2 className="mb-0">X Multiplier Calculator</h2>
                                <div className="iconSR">
                                    <img src="./images/MathOperations.svg" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                        <div className="row m-0 ">
                            <div className="col-md-12 col-xl-12 p-0 CalculatorTop ">
                                <div className="borderBottom ">
                                    <div className="row m-0 ">
                                        <div className="col-md-6  col-xl-2 p-0 borderRight">
                                            <div className="boxes2">
                                                <span className="fInter mb-1">Token Name</span>
                                                <div className="amountSTaking  inputBGCOin d-flex justify-content-between align-items-center gap-3">
                                                    <div className="d-flex gap-2 w-100">
                                                        <img className="img-fluid" src="./images/UFO_big_circle.svg" style={{width:'30px'}} />
                                                        <input className="nobginput p-0 w-100" placeholder="Token Name" type="text" name="" value='UFO' style={{borderRadius:'0px',background:'transparent',border:'0px', padding:'0px'}} readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6  col-xl-6 p-0 borderRight">
                                            <div className="boxes2">
                                                <span className="fInter mb-1">Pair Address</span>
                                                <input
                                                  type="text"
                                                  className="input w-100"
                                                  style={{
                                                    background: "rgb(0 0 0 / 33%)",
                                                    padding: "10px",
                                                    width: "100%",
                                                  }}
                                                  placeholder="0x...."
                                                  value={address}
                                                  onChange={(e) => setAddress(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6  col-xl-2 p-0 borderRight">
                                            <div className="boxes2">
                                                <span className="fInter mb-1">X Factor</span>
                                                <input
                                                  type="text"
                                                  className="input w-100"
                                                  style={{
                                                    background: "rgb(0 0 0 / 33%)",
                                                    padding: "10px",
                                                    width: "100%",
                                                  }}
                                                  placeholder="e.g., 2x or -2x"
                                                  value={xFactor}
                                                  onChange={(e) => {
                                                    let value = e.target.value;
                                                    const validPattern = /^-?\d*\.?\d*x?$/;
                                                    if (validPattern.test(value) || value === "" || value === "-" || value === "." || value === "-.") {
                                                        setXFactor(value);
                                                    }
                                                  }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6  col-xl-2  p-0 "> 
                                            <div className="boxes2">
                                                <span className="fInter mb-1">Paired Token Target Price</span>
                                                <input
                                                  type="text"
                                                  className="input w-100"
                                                  style={{
                                                    background: "rgb(0 0 0 / 33%)",
                                                    padding: "10px",
                                                    width: "100%",
                                                  }}
                                                  placeholder="e.g., $0.05 or 50x"
                                                  value={targetPrice}
                                                  onChange={(e) => {
                                                    let value = e.target.value;
                                                    const validPattern = /^\d*\.?\d*x?$/;
                                                    if (validPattern.test(value) || value === "" || value === "-" || value === "." || value === "-.") {
                                                        setTargetPrice(value);
                                                    }
                                                  }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-2">
                            {
                              address !=="" && xFactor !== "" && targetPrice !== "" ?
                              <>
                               <button className=" borderbtn mybtn w-100 d-flex justify-content-between align-items-center" onClick={() => calculateMultiplier()}>
                                    <span>Calculate</span>
                                    <span className="iconiconSR">
                                        <img className="img-fluid m-0" src="./images/Scales.svg" />
                                    </span>
                                </button>
                              </>
                              :
                              <>
                               <button className=" borderbtn mybtn w-100 d-flex justify-content-between align-items-center" disabled>
                                    <span>Calculate</span>
                                    <span className="iconiconSR">
                                        <img className="img-fluid m-0" src="./images/Scales.svg" />
                                    </span>
                                </button>
                              </>
                            }
                        </div>
                    </div>
                    {
                      showResult ?
                      <>
                      <div className="statsALL ">
                        <div className="bSRIN overHide subcontent  mt-4">
                            <div className="snPortal">
                                <div className="SRTOP d-flex flex-wrap justify-content-between align-items-center">
                                    <h2 className="mb-0">Current Market Prices</h2>
                                    <div className="iconSR">
                                        <img className="img-fluid" src="./images/Coins.svg" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-xl-12 p-0  ">
                                    <div className=" ">
                                        <div className="row m-0">
                                            <div className="col-xl-4 col-lg-6 borderB borderRight p-0">
                                                <div className="snPortal" style={{ padding: "26px 20px" }}>
                                                    <div className="">
                                                        <span className="fInter">{result.pair_ufo.base_symbol} Price</span>
                                                        <h3 className="dollorValue value mt-0">
                                                            <span className="dollor">$</span>
                                                            <span className="val">{parseFloat(result.price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })}</span>
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-6 borderB borderRight p-0">
                                                <div className="snPortal" style={{ padding: "26px 20px" }}>
                                                    <div className="">
                                                        <span className="fInter">{result.pair_ufo.qoute_symbol} Price</span>
                                                        <h3 className="dollorValue value mt-0">
                                                            <span className="dollor">$</span>
                                                            <span className="val">{parseFloat(result.price / result.price_native).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })}</span>
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-4 col-lg-6 borderB  p-0">
                                                <div className="snPortal" style={{borderBottom: "0px", padding: "26px 20px",}}>
                                                    <div className="">
                                                        <span className="fInter">Price Ratio ({result.pair_ufo.base_symbol} / {result.pair_ufo.qoute_symbol})</span>
                                                        <h3 className="dollorValue value mt-0">
                                                            <span className="val">{parseFloat(result.price_native).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })}</span>
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="statsALL ">
                        <div className="bSRIN overHide subcontent  mt-4">
                            <div className="snPortal">
                                <div className="SRTOP d-flex flex-wrap justify-content-between align-items-center">
                                    <h2 className="mb-0">Results</h2>
                                    <div className="iconSR">
                                        <img className="img-fluid" src="./images/circlewithdraw.svg" />
                                    </div>
                                </div>
                            </div>
                           <div className="row">
                                <div className="col-md-12 col-xl-12 p-0  ">
                                    <div className=" ">
                                        <div className="row m-0">
                                            <div className="col-xl-6 borderRight p-0">
                                                <div className="snPortal" style={{ padding: "26px 20px" }}>
                                                    <div className="">
                                                        <span className="fInter">Base UFO Price</span>
                                                        <h3 className="dollorValue value mt-0">
                                                            <span className="dollor">$</span>
                                                            {
                                                              targetPrice ? (
                                                                (() => {
                                                                  let value = 0;

                                                                  if (typeof targetPrice === "string" && targetPrice.toLowerCase().includes("x")) {
                                                                    const multiplier = parseFloat(targetPrice.toLowerCase().replace("x", ""));
                                                                    value = result.price * (isNaN(multiplier) ? 0 : multiplier);
                                                                  } else {
                                                                    const num = parseFloat(result.price_native * targetPrice);
                                                                    value = (isNaN(num) ? 0 : num);
                                                                  }
                                                                  return (
                                                                    <span className="val">
                                                                      {parseFloat(value)
                                                                        .toLocaleString("en-US", {
                                                                          minimumFractionDigits: 2,
                                                                          maximumFractionDigits: 8,
                                                                        })}
                                                                    </span>
                                                                  );
                                                                })()
                                                              ) : (
                                                                <span className="val">
                                                                  {parseFloat(result.price_native).toLocaleString("en-US", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 8,
                                                                  })}
                                                                </span>
                                                              )
                                                            }
                                                        </h3>
                                                        <span className="fInter f12 textgreen">
                                                          {(() => {
                                                            const hasX =
                                                              (typeof targetPrice === "string" && targetPrice.toLowerCase().includes("x"));

                                                            const parseX = (val) => {
                                                              if (!val) return 1;
                                                              const s = val.toLowerCase().trim();
                                                              if (s.endsWith("x")) return parseFloat(s.replace("x", "")) || 1;
                                                              return parseFloat(s) || 1;
                                                            };

                                                            if (hasX) {
                                                              const t = parseX(targetPrice);
                                                              const x = parseX(xFactor);
                                                              const total = t;
                                                              return `${total.toFixed(2)}x Potential`;
                                                            } else {
                                                              const t = parseFloat(targetPrice) || 0;
                                                              const x = parseX(xFactor);

                                                              const potential = calculatePotential(
                                                                result.price,
                                                                result.price_native * t
                                                              );
                                                              return `${potential}x Potential`;
                                                            }
                                                          })()}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-6  p-0">
                                                <div className="snPortal" style={{ padding: "26px 20px" }}>
                                                    <div className="">
                                                        <span className="fInter">Final UFO Price</span>
                                                        <h3 className="dollorValue value mt-0">
                                                            <span className="dollor">$</span>
                                                            <span className="val">
                                                             {
                                                              xFactor && xFactor ? (
                                                                (() => {
                                                                  let value = 0;
                                                                  let XFactorValue = parseFloat(xFactor.toLowerCase().replace("x", ""));
                                                                      XFactorValue = isNaN(XFactorValue) ? 0 : XFactorValue;
                                                                  if (typeof targetPrice === "string" && targetPrice.toLowerCase().includes("x")) {
                                                                    let multiplier = parseFloat(targetPrice.toLowerCase().replace("x", ""));
                                                                    if(XFactorValue > 0)
                                                                    {
                                                                        value = result.price * (isNaN(multiplier) ? 0 : multiplier) * XFactorValue;
                                                                    }
                                                                    else
                                                                    {
                                                                        value = result.price * (isNaN(multiplier) ? 0 : multiplier);
                                                                        const positiveNum = Math.abs(XFactorValue);
                                                                        const positivePotential = parseFloat((value) / positiveNum);
                                                                        const num = parseFloat((value) - (positivePotential));
                                                                        value = (isNaN(num) ? 0 : num);
                                                                    }
                                                                  } else {
                                                                    if(XFactorValue > 0)
                                                                    {
                                                                        const num = parseFloat(result.price_native * targetPrice * XFactorValue);
                                                                        value = (isNaN(num) ? 0 : num);
                                                                    }
                                                                    else
                                                                    {
                                                                        const positiveNum = Math.abs(XFactorValue);
                                                                        const positivePotential = parseFloat((result.price_native * targetPrice) / positiveNum);
                                                                        const num = parseFloat((result.price_native * targetPrice) - (positivePotential));
                                                                        value = (isNaN(num) ? 0 : num);
                                                                    }
                                                                  }
                                                                  return (
                                                                    <span className="val">
                                                                      {parseFloat(value)
                                                                        .toLocaleString("en-US", {
                                                                          minimumFractionDigits: 2,
                                                                          maximumFractionDigits: 8,
                                                                        })}
                                                                    </span>
                                                                  );
                                                                })()
                                                              ) : (
                                                                <span className="val">
                                                                  {parseFloat(result.price_native).toLocaleString("en-US", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 8,
                                                                  })}
                                                                </span>
                                                              )
                                                            }
                                                           </span>
                                                        </h3>
                                                        <span className="fInter f12 textgreen">
                                                          {(() => {
                                                            const hasX =
                                                              (typeof targetPrice === "string" && targetPrice.toLowerCase().includes("x"));

                                                            const parseX = (val) => {
                                                              if (!val) return 1;
                                                              const s = val.toLowerCase().trim();
                                                              if (s.endsWith("x")) return parseFloat(s.replace("x", "")) || 1;
                                                              return parseFloat(s) || 1;
                                                            };

                                                            if (hasX) {
                                                              const t = parseX(targetPrice);
                                                              const x = parseX(xFactor);
                                                              const total = t * x;
                                                              return `${total.toFixed(2)}x Potential`;
                                                            } else {
                                                              const t = parseFloat(targetPrice) || 0;
                                                              const x = parseX(xFactor);
                                                              const potential = calculatePotential(
                                                                result.price,
                                                                result.price_native * t * x
                                                              );
                                                              return `${potential}x Potential`;
                                                            }
                                                          })()}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                      </>
                      :
                      <>
                      </>  
                    }
                    
                </div>
            </div>
        </div>
      </div>
      </>
      );
};

export default XMultiplierCalculator;